import { Component, Event, EventEmitter, Prop, State, h } from '@stencil/core';
import { images } from '../../../helpers/inline-images.service';
import { StsType } from '../../../services/authentication/authentication.models';
import { Header } from '../../navigation-structure.models';
import { LogLevel } from '../../pnl-user-menu/utility/logging.service';
import { getTranslatedLabel } from '../language.util';

@Component({
    tag: 'pnl-mobile-navigation',
    styleUrl: 'pnl-mobile-navigation.scss',
})
export class MobileNavigation {
    @State() open = false;

    @Prop() logLevel: LogLevel = LogLevel.warn;

    @Prop() domain: string;
    @Prop() locale: string;
    @Prop() availableLocales: string;

    @Prop() navigation: Header;

    @Prop() stsType: StsType;
    @Prop() stsServer: string;
    @Prop() clientId: string;
    @Prop() audience: string;
    @Prop() scope: string;
    @Prop() silentRenewPage: string;
    @Prop() silentRenewScript: string;
    @Prop() redirectUri: string = location.origin;
    @Prop() postLogoutRedirectUri: string = location.origin;
    @Prop() bpStsServer: string;
    @Prop() bpClientId: string;

    /**
     * Emits an event when the menu is toggled. event.detail will contains true of the menu was opened, or false when it was closed.
     * You can use this for example to set styling on your application's body to prevent the background from scrolling when the menu is opened.
     */
    @Event() menuToggled: EventEmitter<boolean>;

    toggleMenu() {
        this.open = !this.open;
        this.menuToggled.emit(this.open);

        if (this.open) {
            document.body.classList.add('noscroll');
        } else {
            document.body.classList.remove('noscroll');
        }
    }

    render() {
        return (
            <div class="pnl-header__main pnl-header__main--mobile">
                <div class="pci-inner-container">
                    <button
                        type="button"
                        class="pnl-navigation__toggle--mobile"
                        onClick={() => this.toggleMenu()}
                        aria-controls="pnl-main-nav-menu-container"
                        aria-expanded={this.open.toString()}
                    >
                        <div
                            class="pnl-navigation__toggle-icon"
                            innerHTML={
                                this.open
                                    ? images.closeMenuThick
                                    : images.openMenu
                            }
                        ></div>
                        <span class="visually-hidden">
                            {getTranslatedLabel(this.locale).mainMenu}
                        </span>
                    </button>
                    <a
                        class="pnl-navigation__link pnl-navigation__link--home pnl-navigation__link--home-mobile"
                        href={this.navigation.homeUrl}
                        aria-label={getTranslatedLabel(this.locale).home}
                    >
                        <img
                            src="https://cdn.postnl.nl/images/icons/svg/logo-postnl-outline.svg"
                            alt="PostNL logo"
                        />
                        <span class="visually-hidden">
                            {getTranslatedLabel(this.locale).home}
                        </span>
                    </a>
                    {(this.stsServer || this.bpStsServer) && (
                        <pnl-user-menu
                            log-level={this.logLevel}
                            language={this.locale}
                            domain={this.domain}
                            sts-type={this.stsType}
                            sts-server={this.stsServer}
                            client-id={this.clientId}
                            audience={this.audience}
                            scope={this.scope}
                            silentRenewPage={this.silentRenewPage}
                            silentRenewScript={this.silentRenewScript}
                            redirect-uri={this.redirectUri}
                            post-logout-redirect-uri={
                                this.postLogoutRedirectUri
                            }
                            bp-sts-server={this.bpStsServer}
                            bp-client-id={this.bpClientId}
                        ></pnl-user-menu>
                    )}
                    {this.open && (
                        <div class="pnl-navigation">
                            <div
                                id="pnl-main-nav-menu-container"
                                class="pnl-navigation-container"
                            >
                                <pnl-search
                                    class="pnl-navigation__search"
                                    domain={this.domain}
                                    locale={this.locale}
                                ></pnl-search>
                                <pnl-language-selector
                                    availableLocales={this.availableLocales}
                                    locale={this.locale}
                                ></pnl-language-selector>
                                <pnl-navigation-menu
                                    navigation={this.navigation}
                                    locale={this.locale}
                                ></pnl-navigation-menu>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
